import { CopyOutlined } from "@ant-design/icons";
import { Button, Col, Dropdown, Input, Modal, Row, Space } from "antd";
import { makeComponentLazy } from "libs/react_helpers";
import { useWkSelector } from "libs/react_hooks";
import messages from "messages";
import { ModalWidth } from "theme";
import { useZarrLinkMenu } from "./private_links_view";
import { CopyableSharingLink, useDatasetSharingToken, useSharingUrl } from "./share_modal_view";

const sharingActiveNode = false;

type Props = {
  isOpen: boolean;
  onOk: () => any;
};

function ShareViewDatasetModalViewInner(props: Props) {
  const { isOpen, onOk } = props;
  const dataset = useWkSelector((state) => state.dataset);
  const sharingToken = useDatasetSharingToken(dataset);
  const longUrl = useSharingUrl(isOpen, sharingToken, !dataset.isPublic);

  const {
    baseUrl: zarrBaseUrl,
    copyLayerUrlMenu,
    isLoading: isZarrLinkLoading,
    isUnavailable: isZarrLinkUnavailable,
  } = useZarrLinkMenu(null);
  const isZarrLinkDisabled = isZarrLinkLoading || isZarrLinkUnavailable;

  return (
    <Modal
      title="Share this Dataset"
      open={isOpen}
      width={ModalWidth.Large}
      onOk={onOk}
      onCancel={onOk}
    >
      <Row>
        <Col
          span={6}
          style={{
            lineHeight: "30px",
          }}
        >
          Sharing Link
        </Col>
        <Col span={18}>
          <CopyableSharingLink isVisible={isOpen} longUrl={longUrl} />

          <div
            style={{
              marginBottom: 12,
              margin: "6px 12px",
            }}
          >
            {messages["tracing.sharing_modal_basic_information"](sharingActiveNode)}{" "}
            {!dataset.isPublic
              ? "Additionally, a private token is included in the link, since the dataset is not public."
              : null}
          </div>
        </Col>
      </Row>
      {dataset.isPublic && (
        <Row style={{ marginTop: 16 }}>
          <Col
            span={6}
            style={{
              lineHeight: "30px",
            }}
          >
            Zarr Link
          </Col>
          <Col span={18}>
            <Space.Compact block>
              <Input
                name="zarrPublicSharingLink"
                style={{
                  width: "calc(78% + 32px)",
                }}
                value={
                  isZarrLinkLoading
                    ? "Loading…"
                    : isZarrLinkUnavailable
                      ? "Unavailable"
                      : zarrBaseUrl
                }
                readOnly
              />
              <Dropdown menu={copyLayerUrlMenu} disabled={isZarrLinkDisabled}>
                <Button
                  style={{
                    width: "15%",
                  }}
                  icon={<CopyOutlined />}
                  disabled={isZarrLinkDisabled}
                >
                  Copy
                </Button>
              </Dropdown>
            </Space.Compact>
            <div
              style={{
                marginBottom: 12,
                margin: "6px 12px",
              }}
            >
              {messages["tracing.sharing_modal_zarr_information"]}{" "}
            </div>
          </Col>
        </Row>
      )}
    </Modal>
  );
}

const ShareViewDatasetModalView = makeComponentLazy(ShareViewDatasetModalViewInner);
export default ShareViewDatasetModalView;
